function makeid() {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    for( var i=0; i < 7; i++ )
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    return text;
}

module.exports = {

    preBuild: function(data){
        return {
            type: data['type'],
            controlName: data['controlName'] || '',
            id: data['name'] ? data['name'] + '-' + makeid() : makeid(),
            name: data['name'] || null,
            className: data['className'] ? data['className'] + ' ' + data['name'] : data['name'],
            subType: data['subtype'] || '',
            label: data['label'] || '',
            values: data['values'] || null,
            validation: {
                required: data['required'] || false
            },
            children: [],
            action: {}
        };
    }
};